import React, { useRef } from "react";

import Sidebar from "../Sidebar";
import { Node } from "../../types";

import "../../styles/Functions.css";

/* 
  For code block syntax highlight, see all styles here: https://github.com/highlightjs/highlight.js/tree/main/src/styles
  Could we select a different style for darkmode and lightmode (maybe even dracula)?
*/
import "highlight.js/styles/atom-one-light.css";
import ProcessSection from "./ProcessSection";
import TableOfContentSection from "./TableOfContentSection";

type Props = {
  nodes: Node[];
  network: string;
};

const Functions = ({ nodes, network }: Props) => {
  const data = nodes.filter(
    node => node.functions && node.functions.length > 0
  );
  const printRef = useRef<HTMLInputElement>(null);
  const toc = data.map((node, index) => (
    <TableOfContentSection key={`toc${node.id}-${index}`} node={node} />
  ));

  const functions = data.map((node, index) => (
    <ProcessSection key={`${node.id}-${index}`} node={node} nodes={nodes} />
  ));

  return (
    <div className="be_Functions">
      <Sidebar contentRef={printRef}>{toc}</Sidebar>
      <div className="be_doc" ref={printRef}>
        <h1>{network} functions</h1>
        {functions}
      </div>
    </div>
  );
};

export default Functions;
